<div id="pedidoCancelamento" class="modal fade" aria-hidden="true" #modal>
        <div class="modal-dialog modal-xl modal-dialog-scrollable modal-danger">
            <div class="modal-content" *ngIf="isOpen">
                <div class="modal-header" *ngIf="!isLoading">
                    <h4 class="modal-title" *ngIf="config?.isSimulacao">
                        Cancelar Simulação
                    </h4>
                    <h4 class="modal-title" *ngIf="!config?.isSimulacao">
                        Cancelar Pedido
                    </h4>
                </div>

                <ng-template [ngIf]="isLoading">
                    <div class="modal-body">
                        <p class="text-muted mb-0">
                            <i class='fas fa-spinner fa-pulse'></i> Carregando
                        </p>
                    </div>
                </ng-template>

                <ng-template [ngIf]="!isLoading">
                    <div class="modal-body">
                        <form #form="ngForm" novalidate>
                            <ng-template [ngIf]="pedido">
                                <div class="row">
                                    <div class="form-group col-12 col-md">
                                        <label class="col-form-label">Número</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fas fa-hashtag"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control" [value]="pedido.numero ? pedido.numero : ''" disabled="disabled" readonly="readonly">
                                        </div>
                                    </div>
                                    <div class="form-group col-12 col-md" *ngIf="config?.isOrigemEcommerce">
                                        <label class="col-form-label">Número E-commerce</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fas fa-hashtag"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control" [value]="pedido.numeroEcommerce ? pedido.numeroEcommerce : ''" disabled="disabled" readonly="readonly">
                                        </div>
                                    </div>
                                    <div class="form-group col-12 col-md">
                                        <label class="col-form-label">Número ERP</label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    <i class="fas fa-hashtag"></i>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control" [value]="pedido.numeroErp ? pedido.numeroErp : ''" disabled="disabled" readonly="readonly">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-12 col-md">
                                        <label class="col-form-label">Cliente</label>
                                        <sgt-cliente-form-input-disabled
                                            [codigoIntegracaoErp]="pedido.pessoa?.codigoIntegracaoErp"
                                            [nome]="pedido.pessoa?.nome"
                                            [nomeFantasia]="pedido.pessoa?.nomeFantasia"
                                            [cnpjCpf]="pedido.pessoa?.cnpjCpf"
                                            [nomeCidade]="pedido.pessoa?.nomeCidade"
                                            [uf]="pedido.pessoa?.uf"
                                            [rotaEntregaErpSCR]="pedido.pessoa?.rotaEntregaErpSCR">
                                        </sgt-cliente-form-input-disabled>
                                    </div>
                                    <div class="form-group col-12 col-md" *ngIf="!isRepresentante">
                                        <label class="col-form-label">Representante</label>
                                        <sgt-representante-form-input-disabled
                                            [codigoIntegracaoErp]="pedido.representante?.pessoa?.codigoIntegracaoErp"
                                            [cnpjCpf]="pedido.representante?.pessoa?.cnpjCpf"
                                            [nome]="pedido.representante?.pessoa?.nome"
                                            [nomeFantasia]="pedido.representante?.pessoa?.nomeFantasia">
                                        </sgt-representante-form-input-disabled>
                                    </div>
                                </div>
                            </ng-template>

                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="motivoCancelado" class="col-form-label">Motivo</label>
                                    <sgt-motivo-perda-venda-select
                                        #motivoCanceladoSelect
                                        #motivoCancelado="ngModel"
                                        [(ngModel)]="entity.idMotivoCancelado"
                                        name="motivoCancelado"
                                        id="motivoCancelado"
                                        required="required"
                                        [canSelectNull]="true"
                                        [somenteAtivos]="true"
                                        [perdaVenda]="true">
                                    </sgt-motivo-perda-venda-select>
                                    <p class="form-text text-muted" *ngIf="config?.isSimulacao">Informe o motivo pelo qual esta simulação deve ser cancelada</p>
                                    <p class="form-text text-muted" *ngIf="!config?.isSimulacao">Informe o motivo pelo qual este pedido deve ser cancelado</p>
                                    <sgt-form-control-error
                                        *ngIf="motivoCancelado.errors && motivoCancelado.errors.required && motivoCancelado.dirty"
                                        msgError="O motivo do cancelamento é obrigatório">
                                    </sgt-form-control-error>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group col-12">
                                    <label for="motivoCancelamento" class="col-form-label">Justificativa</label>
                                    <textarea class="form-control" [(ngModel)]="entity.motivo" name="motivoCancelamento" id="motivoCancelamento"
                                        #motivoCancelamento="ngModel" rows="3" sgtAutosize placeholder="Informe a justificativa do cancelamento" required="required" minlength="15" maxlength="500">
                                    </textarea>
                                    <p class="form-text text-muted" *ngIf="config?.isSimulacao">Informe uma justificativa do por que esta simulação deve ser cancelada</p>
                                    <p class="form-text text-muted" *ngIf="!config?.isSimulacao">Informe uma justificativa do por que este pedido deve ser cancelado</p>
                                    <sgt-form-control-error
                                        *ngIf="motivoCancelamento.errors && motivoCancelamento.errors.required && motivoCancelamento.dirty"
                                        msgError="A justificativa do cancelamento é obrigatório">
                                    </sgt-form-control-error>
                                    <sgt-form-control-error
                                        *ngIf="motivoCancelamento.errors && motivoCancelamento.errors.minlength"
                                        msgError="A justificativa deve ter no mínimo 15 caracteres">
                                    </sgt-form-control-error>
                                    <sgt-form-control-error
                                        *ngIf="motivoCancelamento.errors && motivoCancelamento.errors.maxlength"
                                        msgError="A justificativa deve ter no máximo 500 caracteres">
                                    </sgt-form-control-error>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-light" (click)="close()">
                            <i class="fas fa-times"></i> Não Cancelar
                        </button>
                        <button type="button" class="btn btn-danger" (click)="cancel()" id="btnCancelPedido" [disabled]="form.invalid">
                            <ng-template [ngIf]="config?.isSimulacao">
                                <i class="fas fa-ban"></i> Cancelar Simulação
                            </ng-template>
                            <ng-template [ngIf]="!config?.isSimulacao">
                                <i class="fas fa-ban"></i> Cancelar Pedido
                            </ng-template>
                        </button>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
